import { createFileRoute, redirect } from '@tanstack/react-router';
import { cachedSession } from '@/lib/session';

// /onboarding opens the current step (merchant screens §3.1, the wizard frame).
export const Route = createFileRoute('/onboarding/')({
  staticData: { roles: ['owner'] },
  beforeLoad: ({ context }) => {
    const step = cachedSession(context)?.merchant.onboarding_current_step ?? 1;
    throw redirect({ to: '/onboarding/$step', params: { step: String(step) } });
  },
});
